import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import TextEditor from './TextEditor';
import axios from 'axios';
import { host } from '../../../config';
import {
  FormGroup,
  Button,
  ButtonToolbar,
  HelpBlock,
} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import { monthNameFormatDate } from '../../../core/date';
import MembersChangeDates from './MembersChangeDates';
import { filter, resolve } from 'bluebird';
import { displayBuyerBidState, displayBidderBidState } from '../../../core/api';


class HotelDefineBid extends React.Component {
  constructor(props) {
    super(props);
    //debugger
    const group = props.selectedTour.tour.groups.find(o => o.id == props.event.group)

    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
      beforeSaveCell: this.onBeforeSaveCell,
      afterSaveCell: this.onAfterSaveCell,
    };


    const impQuestions = [];
    const additionalQuestion = [];
    const bidData = [];
    const group_id = this.props.event.group;
    const member_data = this.props.selectedTour.tour.members.filter(itm => itm.group.id == group_id ? itm : '');
    const bid_details = this.props.event.bids.bid_details.filter(itm => (itm.group_id == group_id && itm.event_id == this.props.event.id) ? itm : '')
    const group_bid_data = this.props.selectedTour.tour.group_bid_data.filter(itm => itm.group_id == group_id ? itm : '');
    let temp_data = [];
    let temp_group_bid_data = [];

    let newBiddata = [{
      id: [],
      roomType: "Choose Room Types",
      numberOfRooms: '',
      numberOfNights: '',
      date_in: '',
      date_out: ''
    }];

    let bidIDS = []


    // Remove the first empty entry if member_data exists and has data
    if (newBiddata && newBiddata.length > 0) {
      newBiddata.shift();
    }


    for (let i = 0; i < member_data.length; i++) {
      if (member_data[i].group.id == group_id) {
        temp_data = bid_details.filter(itm => (itm.travelprofile_id == member_data[i].id && typeof (itm.id) != 'undefined') ? itm : '')
        //debugger
        temp_group_bid_data = group_bid_data.filter(itm => itm.travelprofile_id == member_data[i].id ? itm : '')
        const Suite = (temp_data.length && temp_data[0].suite !== 'undefined' && temp_data[0].suite !== null) ? temp_data[0].suite : (temp_group_bid_data.length && temp_group_bid_data[0].suite !== 'undefined' && temp_group_bid_data[0].suite !== null) ? temp_group_bid_data[0].suite : 0
        const King = (temp_data.length && temp_data[0].king !== 'undefined' && temp_data[0].king !== null) ? temp_data[0].king : (temp_group_bid_data.length && temp_group_bid_data[0].king !== 'undefined' && temp_group_bid_data[0].king !== null) ? temp_group_bid_data[0].king : 0
        const Double = (temp_data.length && temp_data[0].double !== 'undefined' && temp_data[0].double !== null) ? temp_data[0].double : (temp_group_bid_data.length && temp_group_bid_data[0].double !== 'undefined' && temp_group_bid_data[0].double !== null) ? temp_group_bid_data[0].double : 0
        const NoHotel = !Suite && !King && !Double ? 1 : 0
        bidData.push({
          id: member_data[i].id,
          first_name: member_data[i].first_name !== '' ? member_data[i].first_name : 'Guest',
          last_name: member_data[i].last_name !== '' ? member_data[i].last_name : 'Guest',
          Suite,
          King,
          Double,
          NoHotel,
          check_in_date: temp_data.length ? temp_data[0].check_in_date : this.props.event.start,
          check_out_date: temp_data.length ? temp_data[0].check_out_date : this.props.event.end,
          group_id: this.props.event.group,
          user_id: member_data[i].id,
          bid_detail_id: temp_data.length ? temp_data[0].id : 0,
          bid_id: temp_data.length ? temp_data[0].bid_id : 0
        });
        temp_data.pop();
        //temp_group_bid_data.pop();
      }
    }
    const memersDates = [];
    const dates = [];
    bidData.forEach((bid) => {
      if (dates[0] == bid.check_in_date && dates[1] == bid.check_out_date) {
        console.log("")
      } else {
        dates[0] = bid.check_in_date;
        dates[1] = bid.check_out_date;
        let count = memersDates.length;
        memersDates.push({
          'id': count,
          'check_in_date': bid.check_in_date,
          'check_out_date': bid.check_out_date,
        })
      }
    })
    this.props.ques.questions.forEach((question) => {
      if (question.is_default) {
        impQuestions.push({
          id: question.id,
          question: question.question,
          question_field_type: question.question_field_type,
          sort_order: question.sort_order,
          hide: question.hide,
          is_default: question.is_default,
          is_selected: false
        })
      }
    })
    //debugger
    this.state = {
      toolbar,
      gridData: false,
      chkBoxVal: 1,
      chkBoxvalking: 1,
      chkBoxvaldouble: 1,
      showWarning: false,
      modalText: '',
      group: group,
      viewMap: false,
      showAddHotel: false,
      showHotelDetail: false,
      showHotelDefineBid: false,
      showmodal: false,
      showConfirm: false,
      showSetCheckInOutDate: false,
      showSetRoomTypes: false,
      cellEditProp,
      bidData,
      checkInDateValue: this.props.event.start,
      checkOutDateValue: this.props.event.end,
      roomTypeData: {},
      isApplyDisabled: false,
      location: null,
      impQuestions,
      additionalQuestion: [],
      disabled: false,
      inputVal: false,
      question: null,
      countClick: 0,
      noOfQuestion: 0,
      group_id: this.props.event.group,
      btndis: true,
      showChangeDate: false,
      newBiddata,
      bidIDS,
      isLoading: true,
      confirmPopUP: null,
      CheckBidTableSave: false,
      bidStatus: [],
      editpopup: false,
      editConfirmation: false,
      typeEdit: false,
    };
  }
  componentWillMount() {
    this.setState({
      confirmPopUP: false
    })
    this.setState({
      editConfirmation: false
    })
    this.fetchData()
    // get additional questions according to group id
    let additionalQuest = [];
    this.props.requestTourquestions(this.state.group_id, (response) => {
      if (this.props.addQuestion.questions) {
        this.props.addQuestion.questions.forEach((question) => {
          if (question.group_id == this.state.group_id) {
            additionalQuest.push({
              id: question.id,
              question: question.question,
              question_field_type: question.question_field_type,
              sort_order: question.sort_order,
              hide: question.hide,
              is_default: question.is_default,
              tour_id: question.tour_id,
              group_id: question.group_id
            })
          }
        })
        this.setState({
          additionalQuestion: additionalQuest,
          countClick: this.props.addQuestion.questions.length,
          noOfQuestion: this.props.addQuestion.questions.length,
        })
      } else {
        console.log("data is not avaiable")
      }
    });
    // get selected questions
    this.props.AddedQuestions(this.state.group_id, (response) => {
      if (this.props.selectedQuest.questions) {
        let questions = this.state.impQuestions;
        questions.map((impQuest) => {
          this.props.selectedQuest.questions.forEach((quest) => {
            if (quest.question_id == impQuest.id) {
              impQuest.is_selected = true;
            }
          })
        })
        this.setState({
          impQuestions: questions,
        })
      } else {
        console.log("selected Questions not avaiable")
      }
    });

    if (this.props.event.place.city == null) {
      this.setState({
        location: `${this.props.event.place.state}, ${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.state == null) {
      this.setState({
        location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.city == null && this.props.event.place.state == null) {
      this.setState({
        location: `${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.city == null && this.props.event.place.state == null && this.props.event.place.country == null) {
      this.setState({
        location: '',
      })
    }
    if (this.props.event.place.city != null && this.props.event.place.state != null && this.props.event.place.country != null) {
      if (this.props.event.place.city === this.props.event.place.state) {
        this.setState({
          location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
        })
      } else {
        if (this.props.event.place.state === this.props.event.place.country) {
          this.setState({
            location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
          })
        } else {
          this.setState({
            location: `${this.props.event.place.city}, ${this.props.event.place.state}, ${this.props.event.place.country}`,
          })
        }
      }
    }
  }
  handleCrosscCheckboxClick = (e, row) => {
    console.log(document.querySelector(`#nohotel_${row.id}`));
    document.querySelector(`#nohotel_${row.id}`).click();
  }

  displayBidState(buyerState, bidderState) {
    if (['ST'].includes(buyerState)) {
      return `${displayBuyerBidState(buyerState, bidderState)} (${displayBidderBidState(
        buyerState,
        bidderState
      )})`;
    }
    return displayBuyerBidState(buyerState, bidderState);
  }

  fetchData = () => {
    const { group_id } = this.state;
    const event_id =this.props.event.id
    const { selectedTourId, event } = this.props;
    this.setState({ isLoading: true })
    Promise.all([
      this.fetchBidData(selectedTourId),
      this.fetchBidValue(group_id,event_id),
    ])
      .then(([bidResponse, bidValueResponse]) => {
        this.processBidData(bidResponse.data.results);
        this.showBidData(bidValueResponse.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ isLoading: false });
      });
  }

  fetchBidData = (tour_id) => {
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    return axios.get(`${host}/api/bid/?tour_id=${tour_id}`, {
      headers: {
        Authorization: `Token ${tokenKey}`,
      },
    });
  }

  fetchBidValue = (group_id,event_id) => {
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    return axios.get(`${host}/api/bidvalue/get_bid_value/?group_id=${group_id}&event_id=${event_id}`, {
      headers: {
        Authorization: `Token ${tokenKey}`,
      },
    });
  }

  sendMailHotel(bidStatus){
    const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
    const uploadUrl = `${host}/api/bidvalue/send_edit_message/`;
    return axios.post(uploadUrl, bidStatus, {
      headers: {
          Authorization: `Token ${tokenKey}`,
      },
  })
      .then(() => {
         
      })
      .catch((error) => {
          console.error('Error uploading document:', error);
      });
    

  }

  processBidData = (bids) => {
    const eventPlaceName = this.props.event.place.city
    const eventGroupName = this.props.event.group_name
    const bidStatus = [];
    bids.forEach((bid) => {
      try {
        const displayState = this.displayBidState(bid.buyer_state, bid.bidder_state);
        const hotel_mail = bid.bidder.email
        const agent_name = bid.bidder.username
        const bidGroupName = bid.bidset.event.group_name
        const bidPlaceName = bid.bidset.event.place.city
        if (displayState === 'Accept' && bidGroupName === eventGroupName && bidPlaceName === eventPlaceName ) {
            bidStatus.push({
            displayState: displayState,
            hotel_mail: hotel_mail,
            agent_name: agent_name,
          })

        }
      }catch (error) {
        console.error('Error rendering document content:', error);
    }
    });
    this.setState({
      bidStatus:bidStatus
    })
  }

  showBidData(bid_details) {
    for (let i = 0; i < bid_details.length; i++) {
      this.state.bidIDS.push(
        {
          id: bid_details[i].id,
          king: bid_details[i].king,
          suite: bid_details[i].suite,
          double: bid_details[i].double,
          twobeds: bid_details[i].twobeds,
          Juniorsuite: bid_details[i].Juniorsuite,
          twobedroomsuite: bid_details[i].twobedroomsuite,
          in_date: bid_details[i].check_in_date,
          out_date: bid_details[i].check_out_date
        }
      )
    }
    if (bid_details && bid_details.length > 0) {
      let roomCounter = 0;
      let processedRoomTypes = new Set(); // To avoid storing duplicate room types
      for (let i = 0; i < bid_details.length;) {
        const currentPayload = bid_details[i];
        const roomType = currentPayload.suite ? 'Suite' : currentPayload.king ? 'King' : currentPayload.double ? 'Double' : currentPayload.twobeds ? 'Two Beds' : currentPayload.Juniorsuite ? 'Junior Suite' : '2 Bedroom Suite';
        let uniqueKey = `${roomType}-${bid_details[i].check_in_date}-${bid_details[i].check_out_date}`;
        if (!processedRoomTypes.has(uniqueKey)) {
          let numberOfRooms = 0;
          let dateIn = '';
          let dateOut = '';
          let storeId =[]

          for (let j = i; j < bid_details.length; j++) {
            if (bid_details[j].suite === currentPayload.suite && bid_details[j].king === currentPayload.king && bid_details[j].double === currentPayload.double && bid_details[j].twobeds === currentPayload.twobeds && bid_details[j].Juniorsuite === currentPayload.Juniorsuite && bid_details[j].twobedroomsuite === currentPayload.twobedroomsuite && bid_details[j].check_in_date === currentPayload.check_in_date && bid_details[j].check_out_date === currentPayload.check_out_date) {
              storeId.push(bid_details[j].id)
              numberOfRooms++;
              dateIn = bid_details[j].check_in_date;
              dateOut = bid_details[j].check_out_date;
              processedRoomTypes.add(uniqueKey);
            }
          }
          const diffInTime = new Date(dateOut).getTime() - new Date(dateIn).getTime();
          const diffInDays = diffInTime / (1000 * 3600 * 24);
          let numberOfNights = diffInDays.toString();

          this.state.newBiddata.push({
            id:storeId,
            roomType: roomType,
            numberOfRooms: numberOfRooms,
            date_in: dateIn,
            date_out: dateOut,
            numberOfNights: numberOfNights,
          });

          roomCounter++;
        } else {
          i++;
        }
      }
    }
    this.setState({
      isLoading: false
    })
  }

  onCloseWarning = () => {
    this.setState({
      showWarning: false,
    });
  }
  onCloseConfirm = () => {
    this.setState({
      showConfirm: false,
    });
  }
  onHideEditPop = () => {
    this.setState({
      editpopup: false
    })
  }

  deleteMember = () => {
    const id = this.state.rowData.id;
    const group_id = this.state.rowData.group_id;
    this.props.dispatchRemoveMemberFromGroup(group_id, id);
    this.setState({ rowData: [], showConfirm: false });
  }

  handleShowSetCheckInOut = () => {
    this.setState({
      showSetCheckInOutDate: true
    })
  }

  handleCloseSetCheckInOut = () => {
    this.setState({
      showSetCheckInOutDate: false
    })
  }

  handleShowBulkSetCheckInOut = () => {
    this.setState({
      showbulkCheckInOutDate: true,
    })
  }

  handleCloseBulkSetCheckInOut = () => {
    this.setState({
      showbulkCheckInOutDate: false,
      showForm: false,
      checkedDate: null,
    })
  }

  handleShowSetRoomTypes = () => {
    this.setState({
      showSetRoomTypes: true
    })
  }

  handleCloseSetRoomTypes = () => {
    this.setState({
      showSetRoomTypes: false
    })
  }

  onSubmit = (values) => {
    //debugger;
    let payloaddummy = [];
    let type = "";
    this.props.saveRoomPreferences(this.props.event.group, values);
    let counter = 0
    const { typeEdit } = this.state
    let roomCounter = 0;
    for (let i = 0; i < this.state.newBiddata.length; i++) {
      const formData = this.state.newBiddata[i];
      if (formData.roomType === 'Choose Room Types') {
        continue
      }
      const totalRoomsForFormData = formData.numberOfRooms;
      const bid_ids = formData.id;
      const roomType = formData.roomType === 'Suite' ? 'Suite' : formData.roomType === 'King' ? 'King' : formData.roomType === 'Double' ? 'Double' : '';

 

      for (let j = 0; j < totalRoomsForFormData; j++) {
        const data = this.state.bidData[j % this.state.bidData.length];
        let idToPush = 0; // Initialize with 0
        if (bid_ids && bid_ids.length > j) {
          idToPush = bid_ids[j];
          console.log('When id already exists ------->>>', idToPush);
        } else {
          idToPush = 0;
          console.log("When id doesn't exist, push 0 ------>>>");
        }

        payloaddummy.push({
          suite: formData.roomType === 'Suite',
          king: formData.roomType === 'King',
          double: formData.roomType === 'Double',
          twobeds: formData.roomType === 'Two Beds',
          Juniorsuite: formData.roomType === 'Junior Suite',
          twobedroomsuite: formData.roomType === '2 Bedroom Suite',
          check_in_date: formData.date_in,
          check_out_date: formData.date_out,
          travelprofile_id:0,
          tour_id: this.props.selectedTourId,
          group_id:this.props.event.group,
          bid_id: this.props.selectedTour.bid_id,
          event_id: this.props.event.id,
          room_type: formData.roomType === 'Suite' ? 1 : formData.roomType === 'King' ? 2 : formData.roomType === 'Double' ? 3 : formData.roomType === 'Two Beds' ? 4 : formData.roomType === 'Junior Suite' ? 5 : formData.roomType === '2 Bedroom Suite' ? 6 : 0,// Adjust the logic for room types as per your requirements
          id: idToPush,
          editType: typeEdit
        });
        // console.table(payloaddummy)

        roomCounter++;
        counter++;
      }
    }
    this.setState({
      CheckBidTableSave: true
    })
    if (payloaddummy.length > 0) {
      this.props.addMultipleBidDetail(payloaddummy, 0, (response) => {

        this.props.onClose();
      })
    } else {
      this.props.onClose();
    }
    // this.fetchData()
  }

  onClose = () => {
    // console.log('on close called')
    this.setState({ showmodal: false });
  }
  show = () => {
    // console.log('show called')
    this.setState({ showmodal: true });
  }
  showChangeDatePopUp = () => {
    this.setState({ showChangeDate: true });
  }
  closeChangeDatePopUp = () => {
    this.setState({
      showChangeDate: false,
      showSetCheckInOutDate: false,
    });
  }
  changeBidData = (data) => {
    const bid_detail = data.bid_detail;
    const newBidData = [];
    if (bid_detail.length != 0) {
      bid_detail.map((value) => {
        this.state.bidData.map((val) => {
          if (value.travelprofile_id == val.id) {
            val.check_in_date = value.check_in_date;
            val.check_out_date = value.check_out_date;
            val.Suite = value.suite;
            val.King = value.king;
            val.Double = value.double;
            val.bid_detail_id = value.id;
            newBidData.push(val)
          }
        })
      })
    }
    this.setState({
      showChangeDate: false,
      bidData: newBidData,
    })
  }

  changeCheckBox = (e, row, type) => {

    document.querySelector(`#suite_${row.id}`).disabled = true;
    document.querySelector(`#king_${row.id}`).disabled = true;
    document.querySelector(`#double_${row.id}`).disabled = true;

    const bidData = [...this.state.bidData];
    const data = bidData.find(o => o.id == row.id);

    let output = e.target.checked;

    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        unselectedRoom.push("NoHotel")
        break;
      case 4:
        selectedRoom = "NoHotel"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
    }


    data[selectedRoom] = output ? 1 : 0;
    data[unselectedRoom[0]] = 0;
    data[unselectedRoom[1]] = 0;
    data[unselectedRoom[2]] = 0;
    data["isDisable"] = true

    //debugger
    const payloadBid = { suite: data.Suite, king: data.King, double: data.Double, check_in_date: data.check_in_date, check_out_date: data.check_out_date, travelprofile_id: data.id, tour_id: this.props.selectedTourId, group_id: data.group_id, bid_id: this.props.selectedTour.bid_id, event_id: this.props.event.id, id: data.bid_detail_id, room_type: type };
    this.props.addBidDetail(payloadBid, (response) => {
      data.bid_detail_id = response.id;
      document.querySelector(`#suite_${row.id}`).disabled = false;
      document.querySelector(`#king_${row.id}`).disabled = false;
      document.querySelector(`#double_${row.id}`).disabled = false;
      this.setState({
        bidData
      })
    })

  }

  updateRoomType = (e, row, type, enumObject) => {
    let roomTypeData = {};
    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        unselectedRoom.push("NoHotel")
        break;
      case 4:
        selectedRoom = "NoHotel"
        unselectedRoom.push("Suite")
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    row[selectedRoom] = 1;
    row[unselectedRoom[0]] = 0;
    row[unselectedRoom[1]] = 0;

    roomTypeData['Suite'] = row.Suite;
    roomTypeData['King'] = row.King
    roomTypeData['Double'] = row.Double
    roomTypeData['NoHotel'] = row.NoHotel
    roomTypeData['room_type'] = type

    this.setState({
      roomTypeData: roomTypeData
    })

  }

  handleUpdateRoomTypes = () => {
    this.setState({
      isApplyDisabled: true
    })
    this.handleCloseSetRoomTypes();
    let roomTypePayloadBid = [];
    let roomTypes = this.state.roomTypeData;
    let updatedBidData = this.state.bidData;

    this.state.bidData.forEach((data) => {
      roomTypePayloadBid.push({ suite: roomTypes.Suite, king: roomTypes.King, double: roomTypes.Double, check_in_date: data.check_in_date, check_out_date: data.check_out_date, travelprofile_id: data.id, tour_id: this.props.selectedTourId, group_id: data.group_id, bid_id: this.props.selectedTour.bid_id, event_id: this.props.event.id, id: data.bid_detail_id, room_type: roomTypes.room_type })
    })

    this.props.addMultipleBidDetail(roomTypePayloadBid, 1, (response) => {
      updatedBidData.forEach((bid) => {
        bid.Suite = roomTypes.Suite ? true : false
        bid.King = roomTypes.King ? true : false
        bid.Double = roomTypes.Double ? true : false
        bid.NoHotel = !roomTypes.Suite && !roomTypes.King && !roomTypes.Double ? true : false
      })
      roomTypes.Suite = 0;
      roomTypes.King = 0;
      roomTypes.Double = 0;

      this.setState({
        bidData: updatedBidData,
        roomTypeData: roomTypes,
        isApplyDisabled: false
      })
    })
  }

  handleClick() {
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }

  checkboxFormatter = (cell, row) => {
    const id = `suite_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Suite} onChange={(e) => this.changeCheckBox(e, row, 1)} />
    )
  }

  checkboxnohotelFormatter = (cell, row) => {
    const id = `nohotel_${row.id}`
    const disabled = row.NoHotel ? true : false;

    return (
      <div className='checkbox-with-cross'>
        <input type='checkbox' id={id} checked={row.NoHotel} disabled={disabled} onChange={(e) => this.changeCheckBox(e, row, 4)} />
        <label htmlFor="NoHotel" onClick={(e) => this.handleCrosscCheckboxClick(e, row)}></label>
      </div>
    )
  }

  checkboxkingFormatter = (cell, row) => {
    const id = `king_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.King} onChange={(e) => this.changeCheckBox(e, row, 2)} />
    )
  }

  checkboxdoubleFormatter = (cell, row) => {
    const id = `double_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Double} onChange={(e) => this.changeCheckBox(e, row, 3)} />
    )
  }

  checkboxsuiteFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 1)} />
    )
  }

  checkboxkingFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 2)} />
    )
  }

  checkboxdoubleFormatterRoomType = (cell, row, enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 3)} />
    )
  }

  onBeforeSaveCell = (row, cellName, cellValue) => {

    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      let checkInDate, checkOutDate;
      if (cellName == 'check_in_date') {
        checkInDate = new Date(cellValue);
        checkOutDate = new Date(row.check_out_date);
      } else if (cellName == 'check_out_date') {
        checkInDate = new Date(row.check_in_date);
        checkOutDate = new Date(cellValue);
      }

      if (checkInDate > checkOutDate) {
        this.setState({ showWarning: true, modalText: "Check-in date should be before the check-out date" });
        return false;
      }
    }
  }

  onAfterSaveCell = (row, cellName, cellValue) => {

    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      const isSeleted = row.Suite || row.King || row.Double;
      let type = 0
      if (isSeleted) {

        if (row.Suite)
          type = 1;
        if (row.King)
          type = 2;
        if (row.Double)
          type = 3;

        const payloadBid = { suite: row.Suite, king: row.King, double: row.Double, check_in_date: row.check_in_date, check_out_date: row.check_out_date, travelprofile_id: row.id, tour_id: this.props.selectedTourId, group_id: row.group_id, bid_id: this.props.selectedTour.bid_id, event_id: this.props.event.id, id: row.bid_detail_id, room_type: type };
        this.props.addBidDetail(payloadBid, (response) => {
          console.log(response);
        });
      }
    }

    if (cellName == 'first_name' || cellName == 'last_name') {
      const payload = { id: row.id, first_name: row.first_name, last_name: row.last_name };
      this.props.editMember(row.id, payload);

    }
    var bidData = [...this.state.bidData]
    this.setState({
      bidData
    })
  }

  changeValue = (e, q) => {
    var checked = e.target.checked;
    if (checked == true) {
      let ques = q.question;
      let pk = q.id;
      var payload = { question_id: pk, question: ques, tour_id: this.props.selectedTourId, group_id: this.props.event.group }
      this.props.mapQuestion(payload);
      let questions = this.state.impQuestions;
      questions.map((impQuest) => {
        if (impQuest.id == pk) {
          impQuest.is_selected = true;
        }
      })
      this.setState({
        impQuestions: questions,
      })
    } else {
      let pk = q.id;
      let payload = { question_id: pk, group_id: this.props.event.group }
      this.props.removeAddedQuestion(pk, payload);
      let questions = this.state.impQuestions;
      questions.map((impQuest) => {
        if (impQuest.id == pk) {
          impQuest.is_selected = false;
        }
      })
      this.setState({
        impQuestions: questions,
      })
    }
  }
  handleAddQuestion = () => {
    var input = <input id='inputField' type="text" placeholder="Enter Question" className="form-control" onChange={(e) => this.extraQuestions(e)} />;

    this.setState({
      inputVal: input,
    })
  }
  extraQuestions = (e) => {
    var ques = e.target.value;
    if (ques == '') {
      this.setState({
        btndis: true,
      })
    } else {
      this.setState({
        question: ques,
        btndis: false,
      })
    }
  }
  AddQuestions = () => {
    const value = 10;
    if (this.state.countClick < value) {
      let counter = this.state.countClick + 1;
      let number_question = this.state.noOfQuestion + 1
      let question = this.state.question;
      var payload = { question: question, question_field_type: 'TE', question_number: number_question, hide: false, is_default: false, tour_id: this.props.selectedTourId, group_id: this.props.event.group }
      this.props.createQuestions(payload, (response) => {
        if (this.props.addedQuestion) {
          let quesVal = this.props.addedQuestion.questions;
          let addQuest = this.state.additionalQuestion;
          addQuest.push(quesVal)
          this.setState({
            countClick: counter,
            additionalQuestion: addQuest,
            noOfQuestion: number_question,
          })
        } else {
          console.log("Data is not avaiable")
        }
      })
      document.getElementById("inputField").value = "";
      this.setState({
        btndis: true,
      })
    } else {
      alert("You can add only 'Ten' questions.")
      this.setState({
        inputVal: false,
      })
    }
  }

  clearQuestions = (value) => {
    let id = value.id;
    let group_id = value.group_id;
    this.props.removeQuestion(id, (response) => {
      this.props.requestTourquestions(this.state.group_id, (response) => {
        if (this.props.addQuestion.questions) {
          let addQuest = [];
          this.props.addQuestion.questions.forEach((question) => {
            if (question.group_id == this.state.group_id) {
              addQuest.push({
                id: question.id,
                question: question.question,
                question_field_type: question.question_field_type,
                sort_order: question.sort_order,
                hide: question.hide,
                is_default: question.is_default,
                tour_id: question.tour_id,
                group_id: question.group_id
              })
            }
          })
          this.setState({
            additionalQuestion: addQuest,
            countClick: this.props.addQuestion.questions.length,
            noOfQuestion: this.props.addQuestion.questions.length,

          })
        } else {
          console.log("data is not avaiable")
        }
      });
    });
  }

  handlDateChange = (event) => {
    let dateField = event.target.name;
    if (dateField == 'checkInDate') {
      this.setState({
        checkInDateValue: event.target.value
      })
    } else {
      this.setState({
        checkOutDateValue: event.target.value
      })
    }
  }
  changeMembersDate = (e) => {
    let members = e.target.value;
    if (isNaN(members)) {
      alert("Please enter number")
    } else {
      this.setState({
        members: members
      })
    }
  }
  addChangedDate(val) {
    const changeDateData = [];
    const checkIn = val.check_in_date;
    const checkOut = val.check_out_date;
    let group = 0;
    let count = 0;
    const bid_details_ids = [];
    const travelMembers = [];
    this.state.bidData.forEach((bid) => {
      if (checkIn == bid.check_in_date && checkOut == bid.check_out_date) {
        group = bid.group_id;
        if (bid.bid_detail_id > 0) {
          bid_details_ids.push(bid.bid_detail_id)
        } else {
          travelMembers.push(bid.id)
        }
        count = count + 1
      }
    })
    changeDateData.push({
      check_in_date: checkIn,
      check_out_date: checkOut,
      members: count,
      event_check_in: this.props.event.start,
      event_check_out: this.props.event.end,
      bid_details_ids: bid_details_ids,
      travel_members: travelMembers,
      tour_id: this.props.selectedTourId,
      event_id: this.props.event.id,
      group_id: group
    })
    this.setState({
      oldMembersDates: changeDateData,
      members: count,
      addChangedMembers: count,
      checkInDateValue: checkIn,
      checkOutDateValue: checkOut,
    })
  }
  addDate(val) {
    let id = val.id;
    this.setState({
      checkedDate: id,
      showForm: true,
      selectedCheckInDate: val.check_in_date,
      selectedCheckOutDate: val.check_out_date,
    })
    this.addChangedDate(val);
  }
  changeDatesAfterUpdates(response) {
    const bid_detail = response.bid_detail;
    const data = this.state.bidData;
    const newData = [];
    bid_detail.map((val) => {
      data.map((bid) => {
        if (bid.id == val.travelprofile_id) {
          bid.check_in_date = val.check_in_date;
          bid.check_out_date = val.check_out_date;
          bid.bid_detail_id = val.id;
          newData.push(bid)
        }
      })
    })
    const newMemersDates = [];
    const dates = [];
    newData.forEach((bid) => {
      if (dates[0] == bid.check_in_date && dates[1] == bid.check_out_date) {
        console.log("same date")
      } else {
        dates[0] = bid.check_in_date;
        dates[1] = bid.check_out_date;
        let count = newMemersDates.length;
        newMemersDates.push({
          'id': count,
          'check_in_date': bid.check_in_date,
          'check_out_date': bid.check_out_date,
        })
      }
    })
    this.setState({
      checkInDateValue: this.props.event.start,
      checkOutDateValue: this.props.event.end,
      oldMembersDates: null,
      showForm: false,
      showbulkCheckInOutDate: false,
      members: null,
      bidData: newData,
      memersDates: newMemersDates,
      checkedDate: null,
    })
  }

  submitNewDates = () => {
    const oldData = this.state.oldMembersDates;
    const members = this.state.members;
    const checkIn = this.state.checkInDateValue;
    const checkOut = this.state.checkOutDateValue;
    let oldCheckIn = null;
    let oldCheckOut = null;
    let noOfMembers = null;
    let old = null;
    oldData.map((val) => {
      old = val;
      oldCheckIn = val.check_in_date;
      oldCheckOut = val.check_out_date;
      noOfMembers = val.members;
    })
    if (members == 0) {
      this.setState({ showWarning: true, modalText: "Please enter Valid Participants number" })
      return false;
    }
    if (members > noOfMembers) {
      this.setState({ showWarning: true, modalText: "Please enter Valid Participants number. The participant's number should not greater than the existing Participants, which have same Check-In/Out date." })
      return false;
    }
    if (checkIn == oldCheckIn && checkOut == oldCheckOut) {
      this.setState({ showWarning: true, modalText: "Please enter a valid check-in/out date. check-In/Out date should be Different than the existing date." });
      return false;
    }
    if (checkOut < checkIn) {
      this.setState({ showWarning: true, modalText: "Please enter a valid check-in/out date. check-in date should be earlier than the check-out date." });
      return false;
    }
    const payload = { 'old_data': old, 'members': members, 'check_in': checkIn, 'check_out': checkOut }
    this.props.addBulkMultipleBidDetail(payload, (response) => {
      this.changeDatesAfterUpdates(response);
    })

  }

  handleSetCheckInOutDate = () => {
    this.setState({ showSetCheckInOutDate: false })
    if (this.state.checkOutDateValue < this.state.checkInDateValue) {
      this.setState({ showWarning: true, modalText: "Please enter a valid check-in/out date. check-in date should be earlier than the check-out date." });
      return false;
    } else if (this.state.checkOutDateValue == '' || this.state.checkInDateValue == '') {
      this.setState({ showWarning: true, modalText: "Check-in/out date should not be blank." });
      return false;
    }

    let bidDataToUpdate = this.state.bidData;
    let start = document.getElementById('checkInDate');
    let end = document.getElementById('checkOutDate');

    let payloadBid = [];
    let type = "";

    this.state.bidData.forEach((data) => {
      type = data.Suite ? 1 : data.King ? 2 : data.Double ? data.Double ? 3 : 0 : 0
      if (type > 0) {
        payloadBid.push({ suite: data.Suite, king: data.King, double: data.Double, check_in_date: start.value, check_out_date: end.value, travelprofile_id: data.id, tour_id: this.props.selectedTourId, group_id: data.group_id, bid_id: this.props.selectedTour.bid_id, event_id: this.props.event.id, id: data.bid_detail_id, room_type: type })
      }
    })
    if (payloadBid.length > 0) {
      this.props.addMultipleBidDetail(payloadBid, 1, (response) => {
        this.props.onSetCheckInOutDates(start.value, end.value, this.props.event.id);
        bidDataToUpdate.forEach((bid) => {
          bid.check_in_date = start.value;
          bid.check_out_date = end.value;
        })
        this.setState({ bidData: bidDataToUpdate })
      })
    } else {
      bidDataToUpdate.forEach((bid) => {
        bid.check_in_date = start.value;
        bid.check_out_date = end.value;
      })
      this.setState({ bidData: bidDataToUpdate, })
    }
  }
  renderShowsTotal(start, to, total) {
    if (total == 0) {
      return (
        <span></span>
      )
    } else {
      return (
        <p id="bidsetTableListingPerPage" style={{ paddingLeft: 0, margin: 20 }}>
          25 Records/Page &nbsp;&nbsp;(From {start} to {to}, Total is {total})
        </p>
      );
    }
  }
  trStyle = (row, rowIndex) => {
    return { backgroundColor: typeof (row) != 'undefined' ? row.bgcolor : '' };
  }

  handleCellEdit = (row, fieldName, value) => {
    this.setState(prevState => {
      let updatedRows;
      let index;

      if (prevState.newBiddata.length === 0) {
        // If newBiddata is empty, handle the empty case
        updatedRows = [{ ...row, [fieldName]: value }];
        index = 0;
      } else {
        // If newBiddata has data, find the index as before
        index = prevState.newBiddata.findIndex(item =>
          Object.keys(row).every(key => item[key] === row[key])
        );

        updatedRows = [...prevState.newBiddata];
        updatedRows[index][fieldName] = value;
      }

      // Calculate numberOfNights when both dates are filled
      const { date_in, date_out } = updatedRows[index];
      if (date_in && date_out) {
        const diffInTime = new Date(date_out).getTime() - new Date(date_in).getTime();
        const diffInDays = diffInTime / (1000 * 3600 * 24);
        updatedRows[index].numberOfNights = diffInDays.toString();
      }

      return { newBiddata: updatedRows };
    });
  };
  showBidStatus = () => {
    this.setState({
      editpopup: true
    })
  }

  oncloseDefinebid = () => {

    if (this.state.CheckBidTableSave) {
      this.setState({
        confirmPopUP: false
      })
      this.props.onClose();
    }
    else {
      this.setState({
        confirmPopUP: true
      })
    }
  }
  confirmPopUPClose = () => {
    this.setState({
      confirmPopUP: false
    })
  }
  confirmPopUPConfirm = () => {
    this.props.onClose()
  }


  handleAddRow = () => {
    const { newBiddata } = this.state;
    const emptyRow = {
      roomType: 'Choose Room Types',
      id:0,
      numberOfRooms: '',
      date_in: '',
      date_out: '',
      numberOfNights: ''
      // Add other fields as needed
    };

    // Add the new empty row to the state
    this.setState({
      newBiddata: [...newBiddata, emptyRow],
    });
  };
  handleRemoveEmptyRows = () => {
    this.setState(prevState => {
      const updatedRows = prevState.newBiddata.filter(
        row =>
          row.roomType.trim() !== '' ||
          row.numberOfRooms.trim() !== '' ||
          row.date_in.trim() !== '' ||
          row.date_out.trim() !== '' ||
          row.numberOfNights.trim() !== ''
        // Add other conditions if needed
      );

      return { newBiddata: updatedRows };
    });
  };

  mailSentConfirm = () => {
    this.setState({
      editConfirmation: true
    })
  }

  sendTypeEdit = () => {
    const { bidStatus } = this.state;
    this.setState({ typeEdit: true }, () => {
      this.onSubmit();
      this.sendMailHotel(bidStatus);
    });
  };

  closeTypeEdit = () => {
    this.setState({ typeEdit: true }, () => {
      this.onSubmit();
    });
  };

  render() {
    const selectRoomTypeOptions = ['Suite', 'King', 'Double', 'Two Beds', 'Junior Suite', '2 Bedroom Suite'];
    const { newBiddata } = this.state;
    const isEmpty = newBiddata.length === 0;

    const options = {

    };
    const groupData = []
    const check_in_arr = []
    const check_out_arr = []
    this.state.bidData.map(c => {
      const check_in_data = check_in_arr.findIndex(o => o == c.check_in_date)
      const check_out_data = check_out_arr.findIndex(o => o == c.check_out_date)
      if (check_in_data == -1) {
        check_in_arr.push(c.check_in_date)
      }

      if (check_out_data == -1) {
        check_out_arr.push(c.check_out_date)
      }
    })


    const uniquecheckin = [...new Set(check_in_arr)];
    const uniquecheckout = [...new Set(check_out_arr)];
    const element = <span style={{ color: 'green' }}>Multiple Dates</span>;

    const isSaveDisabled = this.state.bidData.length !== this.props.event.bids.bid_details.filter(o => o.suite || o.double || o.king).length

    groupData.push({
      group: this.props.event.group_name,
      group_id: this.props.event.group
    })
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.oncloseDefinebid}>
          <Modal.Header closeButton >
            <Modal.Title>Define Bid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form
              onSubmit={this.onSubmit}
              initialValues={this.state.group.hotel_prefs}
              render={({ handleSubmit, pristine, invalid }) => (
                <form onSubmit={handleSubmit}>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12 left-padding-zero">
                        <h4>{this.props.event.place.name} ({this.state.location})</h4>
                        <p>
                          <h4>{this.props.event.group_name}</h4>
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      {this.state.bidStatus.length > 0 ?
                        (<div> <Button bsStyle="info" onClick={this.showBidStatus} style={{ margin: '12px 12px' }} >Edit Bid</Button>&nbsp;&nbsp;<small style={{ color: "green" }}>Click on Edit Bid button for changing the room type & check In/Out date.</small></div>)
                        : ''}
                      {this.state.isLoading == true ? (
                        <div style={{ padding: '0px 0px 30px 280px' }}>
                          <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
                          <span className="sr-only">Loading...</span>
                        </div>) : (
                        <div>
                          {isEmpty ? (
                            <BootstrapTable
                              data={[{
                                roomType: 'Choose Room Types',
                                numberOfRooms: '',
                                date_in: '',
                                date_out: '',
                                numberOfNights: ''
                              }]}
                              striped
                              cellEdit={{
                                mode: 'click',
                                blurToSave: true,
                                afterSaveCell: this.handleCellEdit
                              }}
                            >
                              <TableHeaderColumn hidden isKey dataField="id" width="100">
                                ID
                              </TableHeaderColumn>
                              <TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
                                editable={{
                                  type: 'select',
                                  options: { values: selectRoomTypeOptions },
                                  validator: (value) => value !== ''
                                }}
                              >
                                Room Type
                              </TableHeaderColumn>
                              <TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
                              <TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                              <TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                              <TableHeaderColumn dataField="numberOfNights" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of nights</TableHeaderColumn>
                            </BootstrapTable>
                          ) : (
                            <BootstrapTable
                              data={this.state.newBiddata}
                              striped
                              cellEdit={{
                                mode: 'click',
                                blurToSave: true,
                                afterSaveCell: this.handleCellEdit
                              }}
                            >
                              <TableHeaderColumn hidden isKey dataField="id" width="100">
                                ID
                              </TableHeaderColumn>
                              <TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
                                editable={{
                                  type: 'select',
                                  options: { values: selectRoomTypeOptions },
                                  validator: (value) => value !== ''
                                }}
                              >
                                Room Type
                              </TableHeaderColumn>
                              <TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
                              <TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                              <TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                              <TableHeaderColumn dataField="numberOfNights" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of nights</TableHeaderColumn>
                            </BootstrapTable>
                          )
                          }
                        </div>
                      )}
                      {/*<Button bsStyle="danger btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.handleRemoveEmptyRows}>Remove</Button>*/}
                      <Button bsStyle="success btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.handleAddRow}>Add</Button>
                    </div>
                    <div className="row">
                      <div className="col-md-12 left-padding-zero">
                        {/*
                        <div>
                           <h4><b>Bid Details</b> <small style={{ color: "red"}}>(Select question you want to included)</small></h4>
                           <ol type='1'>
                              {this.state.impQuestions.map((q) => (
                              <li><FormGroup>
                                <label>
                                  <input type="checkbox" checked={q.is_selected} onChange={(e) => this.changeValue(e,q)}/>
                                  {q.question}
                                </label>
                              </FormGroup></li>
                              ))}
                           </ol>
                        </div> */}
                        <div>
                          <h4><b>Additional Questions</b> <small style={{ color: "red" }}>(Add upto 10 questions)</small></h4>
                          <ol type='1'>
                            {this.state.additionalQuestion.map((value) => (
                              <div>
                                {value.question ? (
                                  <div className="row margin-top-5">
                                    <li>
                                      <div className="col-md-9"><h4>{value.question}</h4></div>
                                      <div className="col-md-2"><Button bsStyle="danger btn-sm" onClick={() => this.clearQuestions(value)}><i className="fa fa-trash" />Clear</Button></div>
                                    </li>
                                  </div>
                                ) : ('')}
                              </div>
                            ))}
                          </ol>
                        </div>
                        <div>
                          <Button bsStyle="success" disabled={this.state.disabled} onClick={this.handleAddQuestion}><i className="fa fa-plus" /> Add Question</Button><br />
                          {this.state.inputVal ? (
                            <div className="row">
                              <div className="col-md-10">{this.state.inputVal}</div>
                              <div className="col-md-2"><Button bsStyle="success" disabled={this.state.btndis} onClick={this.AddQuestions}> Add </Button></div>
                            </div>
                          ) : ('')}
                        </div><br />
                        <h4><b>Additional Bid Notes</b></h4>
                        <FormGroup>
                          <Field
                            name="note_json"
                            type="textarea"
                            component={TextEditor}
                            placeholder="Lodging requests for this group. This note will be included in all tour stops."
                          />
                          <HelpBlock>
                            Lodging requests for this group. This note will be included in all tour stops.
                          </HelpBlock>
                        </FormGroup>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 left-padding-zero">
                        <FormGroup>
                          <ButtonToolbar>
                            <Button bsStyle="success" type="submit">
                              Save
                            </Button>
                            <Button bsStyle="success" onClick={this.oncloseDefinebid}>
                              Cancel
                            </Button>
                          </ButtonToolbar>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            />
          </Modal.Body>
          <Modal.Footer />
        </Modal>
        {this.state.editpopup && <Modal id='EditTop' style={{ width: '100%', height: '70%', marginTop: '10%' }} show={this.state.editpopup} onHide={this.onHideEditPop}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Bid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={this.onSubmit}
              render={({ handleSubmit, pristine, invalid }) => (
                <form onSubmit={handleSubmit}>
                  <BootstrapTable
                    data={this.state.newBiddata}
                    striped
                    cellEdit={{
                      mode: 'click',
                      blurToSave: true,
                      afterSaveCell: this.handleCellEdit
                    }}
                  >
                    <TableHeaderColumn hidden isKey dataField="id" width="100">
                      ID
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
                      editable={{
                        type: 'select',
                        options: { values: selectRoomTypeOptions },
                        validator: (value) => value !== ''
                      }}
                    >
                      Room Type
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
                    <TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                    <TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
                    <TableHeaderColumn dataField="numberOfNights" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of nights</TableHeaderColumn>
                  </BootstrapTable>

                  <Button bsStyle="success btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.handleAddRow}>Add</Button>
                  <Button bsStyle="success btn-sm" style={{ margin: "12px 12px", width: '10%', float: 'right' }} onClick={this.mailSentConfirm} >Save</Button>
                </form>
              )}
            />

          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>}

        {this.state.editConfirmation && (<Modal show={this.state.editConfirmation} onHide={this.closeTypeEdit} >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Mail sent</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you want to notifiy hotel</p>
            <ButtonToolbar>
              <Button bsStyle="success btn-sm" onClick={this.sendTypeEdit}>
                Yes
              </Button>
              <Button bsStyle="danger btn-sm" onClick={this.closeTypeEdit} >
                No
              </Button>
            </ButtonToolbar>

          </Modal.Body>
        </Modal>)}

        {this.state.confirmPopUP && (<Modal show={this.state.confirmPopUP} onHide={this.confirmPopUPClose} >
          <Modal.Header closeButton>
            <Modal.Title>Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you want to save define bid</p>
            <ButtonToolbar>
              <Button bsStyle="success btn-sm" onClick={this.confirmPopUPClose} >
                Yes
              </Button>
              <Button bsStyle="danger btn-sm" onClick={this.confirmPopUPConfirm} >
                No
              </Button>
            </ButtonToolbar>
          </Modal.Body>
        </Modal>)}

        {this.state.showWarning && (<Modal show={this.state.showWarning} onHide={this.onCloseWarning}>
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {this.state.modalText}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.onCloseWarning}
              >
                Ok
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
        {this.state.showChangeDate && (
          <MembersChangeDates
            showChangeDate={this.state.showChangeDate}
            closeChangeDatePopUp={this.closeChangeDatePopUp}
            changeBidData={this.changeBidData}
            bidData={this.state.bidData}
            event={this.props.event}
            tour_id={this.props.selectedTourId}
            addBulkMultipleBidDetail={this.props.addBulkMultipleBidDetail}
          />
        )}

        {this.state.showSetRoomTypes && (<Modal show={this.state.showSetRoomTypes} onHide={this.handleCloseSetRoomTypes} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Default Room Types</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="setRoomTypeModalSection">
              <BootstrapTable
                data={groupData}
                striped
              >
                <TableHeaderColumn dataField="group" width="80" headerAlign="center" dataAlign="center" editable={false} >Group</TableHeaderColumn>
                <TableHeaderColumn dataField="Suite" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxsuiteFormatterRoomType} editable={false}>Suite</TableHeaderColumn>
                <TableHeaderColumn dataField="King" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxkingFormatterRoomType} editable={false}>King</TableHeaderColumn>
                <TableHeaderColumn dataField="Double" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxdoubleFormatterRoomType} editable={false}>Double</TableHeaderColumn>
                <TableHeaderColumn dataField="group_id" isKey width="1" headerAlign="center" dataAlign="center" hidden>Group ID</TableHeaderColumn>
              </BootstrapTable>
            </div>
            <ButtonToolbar className="margin-top-5" style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.handleUpdateRoomTypes}
                disabled={this.state.isApplyDisabled}
              >
                Apply
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

        {this.state.showConfirm && (<Modal show={this.state.showConfirm} onHide={this.onCloseConfirm}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> Are you sure want to delete member?</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.deleteMember}
              >
                Confirm
              </Button>
              <Button
                bsStyle="success"
                onClick={this.onCloseConfirm}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
        {this.state.showbulkCheckInOutDate && (
          <Modal show={this.state.showbulkCheckInOutDate} onHide={this.handleCloseBulkSetCheckInOut}>
            <Modal.Header closeButton>
              <Modal.Title>bulk change Check In/Out Dates</Modal.Title>
            </Modal.Header>
            <Modal.Body><br />
              <h4>Change Check-In/Out date</h4><br />
              <div className="row">
                {this.state.memersDates.map((val) => (
                  <div className="col-sm-6 col-md-6">
                    <input type="radio" key={val.id} checked={this.state.checkedDate == val.id ? true : false} onChange={() => this.addDate(val)} />&nbsp;{val.check_in_date + ' To ' + val.check_out_date}
                  </div>
                ))}
              </div>
              {this.state.showForm && (
                <div><br />
                  <p>These are {this.state.addChangedMembers} participants who have the {this.state.selectedCheckInDate + ' To ' + this.state.selectedCheckOutDate} Check-In/Out date.</p>
                  No of Participants:
                  <input type="text" id="members" name="members" className="form-control" value={this.state.members} onChange={this.changeMembersDate} max={this.state.membersCount} required /><br /><br />
                  Check In Date:
                  <input type="date" id="checkInDate" name="checkInDate" className="form-control" value={this.state.checkInDateValue} onChange={this.handlDateChange} max={"9999-12-31"} required /><br /><br />
                  Check Out Date:
                  <input type="date" id="checkOutDate" name="checkOutDate" className="form-control" value={this.state.checkOutDateValue} onChange={this.handlDateChange} max={"9999-12-31"} required /><br /><br />
                  <ButtonToolbar style={{ float: 'right' }}>
                    <Button
                      bsStyle="success"
                      onClick={this.submitNewDates}
                    >
                      Apply
                    </Button>
                  </ButtonToolbar><br />
                </div>
              )}
            </Modal.Body>
            <Modal.Footer style={{ clear: 'both' }} />
          </Modal>
        )}
      </div>

    );
  }
}

HotelDefineBid.propTypes = {

};

export default HotelDefineBid;


// WEBPACK FOOTER //
// src/routes/tours/components/HotelDefineBid.js